export enum VoteType {
    Up = "up",
    Down = "down",
}

export default VoteType
